import {
  demoAddComment,
  demoDeleteComment,
  demoDeleteReaction,
  demoEnabled,
  demoEntry,
  demoFeed,
  demoInteractions,
  demoSetReaction,
} from "./demoData.js";

export async function api(path, options = {}) {
  const { headers: optionHeaders = {}, ...fetchOptions } = options;
  const response = await fetch(path, {
    credentials: "same-origin",
    ...fetchOptions,
    headers: {
      "Content-Type": "application/json",
      ...optionHeaders,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data?.error?.message || "request-failed");
    error.status = response.status;
    throw error;
  }
  return data;
}

export function redeemWebInvite(inviteId, token) {
  return api(`/api/web/invites/${encodeURIComponent(inviteId)}/redeem`, {
    method: "POST",
    headers: { "x-kinlo-web-action": "redeem-invite" },
    body: JSON.stringify({ token, rememberDevice: true }),
  });
}

export function fetchSession() {
  return api("/api/web/session");
}

export function fetchFeed() {
  if (demoEnabled()) return Promise.resolve(demoFeed());
  return api("/api/web/feed");
}

export function fetchEntry(projectionId) {
  if (demoEnabled()) return Promise.resolve(demoEntry(projectionId));
  return api(`/api/web/entries/${encodeURIComponent(projectionId)}`);
}

export function fetchInteractions(projectionId) {
  if (demoEnabled()) return Promise.resolve(demoInteractions(projectionId));
  return api(`/api/web/entries/${encodeURIComponent(projectionId)}/interactions`);
}

export function addComment(projectionId, text) {
  if (demoEnabled()) return Promise.resolve(demoAddComment(projectionId, text));
  return api(`/api/web/entries/${encodeURIComponent(projectionId)}/interactions/comments`, {
    method: "POST",
    headers: { "x-kinlo-web-action": "add-comment" },
    body: JSON.stringify({ text }),
  });
}

export function deleteComment(projectionId, interactionId) {
  if (demoEnabled()) return Promise.resolve(demoDeleteComment(projectionId, interactionId));
  return api(
    `/api/web/entries/${encodeURIComponent(projectionId)}/interactions/comments/${encodeURIComponent(interactionId)}`,
    {
      method: "DELETE",
      headers: { "x-kinlo-web-action": "delete-comment" },
    },
  );
}

export function setReaction(projectionId, emoji) {
  if (demoEnabled()) return Promise.resolve(demoSetReaction(projectionId, emoji));
  return api(
    `/api/web/entries/${encodeURIComponent(projectionId)}/interactions/reactions/${encodeURIComponent(emoji)}`,
    {
      method: "PUT",
      headers: { "x-kinlo-web-action": "set-reaction" },
    },
  );
}

export function deleteReaction(projectionId, emoji) {
  if (demoEnabled()) return Promise.resolve(demoDeleteReaction(projectionId, emoji));
  return api(
    `/api/web/entries/${encodeURIComponent(projectionId)}/interactions/reactions/${encodeURIComponent(emoji)}`,
    {
      method: "DELETE",
      headers: { "x-kinlo-web-action": "delete-reaction" },
    },
  );
}

export function forgetSession() {
  if (demoEnabled()) return Promise.resolve({ success: true });
  return api("/api/web/session/forget", {
    method: "POST",
    headers: { "x-kinlo-web-action": "forget-session" },
    body: "{}",
  });
}
